<template>
  <div class="step1">
    <div class="content">
      <div class="form">
        <!-- 请填写下列作品信息。 -->
        <div style="font-size: 18px;">
          {{ $t('user-productInfo-product/tip2') }}
        </div>
        <!-- 标注*号的为必填项 -->
        <div style="font-size: 14px;color: #999999;margin-top: 4px;">
          <font color="#ed1c24" />{{ $t('register/tip5') }}
        </div>
        <a-form
          class="ant-advanced-search-form formBox"
          :form="form"
        >
          <a-row :gutter="24">
            <a-col
              span="24"
              style="margin-bottom: 34px;"
            >
              <!-- 类别 -->
              <a-form-item
                :label="$t('admin-profile-product/type')"
                required
                style="margin-top: 27px;"
              >
                <a-select
                  v-model="form.category_id"
                  :disabled="readonly"
                  placeholder="请选择类别"
                  @change="handleTypeChange"
                >
                  <a-select-option
                    v-for="i in cates"
                    :key="i.value"
                    :value="i.value"
                  >
                    {{ i.name }}
                  </a-select-option>
                </a-select>
                <!-- <a :href="`javascript: window.open('${request.defaults.baseURL}/storage/pdf/leibie.pdf');`" class="tip">{{ $t('user-productInfo-product/categoryTip') }}</a> -->
              </a-form-item>
            </a-col>
            <a-col
              span="12"
            >
              <!-- 作品名称 -->
              <a-form-item
                :label="$t('user-productInfo-product/productName')"
                required
              >
                <a-input
                  v-model="form.name_cn"
                  :disabled="readonly"
                />
              </a-form-item>
            </a-col>
            <!-- 作品类型 -->
            <!-- <a-col
              span="12"
            >
              <a-form-item
                :label="$t('user-productInfo-product/type')"
                required
              >
                <a-input
                  v-model="form.type_cn"
                  :disabled="readonly"
                  :placeholder="$t('view-components-components/example')"
                />
              </a-form-item>
            </a-col> -->
            <a-col
              span="12"
            >
              <!-- 指导老师 -->
              <a-form-item
                :label="$t('user-productInfo-product/supervisor')"
              >
                <a-input
                  v-model="form.type_cn"
                  :disabled="readonly"
                />
              </a-form-item>
            </a-col>
            <a-col
              v-if="form.channel_type===10"
              span="12"
            >
              <a-form-item label="填写其他渠道">
                <a-input
                  v-model="form.channel_remark"
                  :disabled="readonly"
                />
              </a-form-item>
            </a-col>
            <a-col
              span="12"
            >
              <!-- 是否申请专利 -->
              <a-form-item
                :label="$t('user-productInfo-product/patentApplied')"
                required
              >
                <a-radio-group v-model="form.channel_type" :disabled="readonly">
                  <a-radio value="1">{{ $t('user-productInfo-product/yes') }}</a-radio>
                  <a-radio value="2">{{ $t('user-productInfo-product/no') }}</a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>

            <!-- <a-col
              v-if="form.channel_type === 6 || form.channel_type === 7"
              span="12"
              style="padding-top: 39px;"
            >
              <a-form-item
                required
              >
                <a-input
                  v-model="form.channel_remark"
                  :disabled="readonly"
                  placeholder=""
                />
              </a-form-item>
            </a-col> -->
            <!-- 推荐码  -->
            <!-- <a-col
              span="12"
            >
              <a-form-item
                :label="$t('user-comphonents-step1/referral-code')"
                required
              >
                <a-input
                  v-model="form.commission_id"
                  :disabled="readonly"
                />
              </a-form-item>
            </a-col> -->
            <a-col
              span="12"
            >
              <!-- 是否进行版权登记 -->
              <a-form-item
                :label="$t('user-productInfo-product/copyrightRegistered')"
                required
              >
                <a-radio-group v-model="form.commission_id" :disabled="readonly">
                  <a-radio value="1">{{ $t('user-productInfo-product/yes') }}</a-radio>
                  <a-radio value="2">{{ $t('user-productInfo-product/no') }}</a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col
              v-if="$store.getters.user.role !== 1"
              span="24"
            >
              <!-- 作品标签 -->
              <a-form-item
                :label="$t('user-comphonents-step1/product-label')"
                class="writePlate"
                :class="{disabled: readonly}"
              >
                <template v-for="tag in tags">
                  <a-tooltip v-if="tag.length > 20" :key="tag" :title="tag">
                    <a-tag :key="tag" :closable="!readonly" @close="() => handleClose(tag)">
                      {{ `${tag.slice(0, 20)}...` }}
                    </a-tag>
                  </a-tooltip>
                  <a-tag v-else :key="tag" :closable="!readonly" @close="() => handleClose(tag)">
                    {{ tag }}
                  </a-tag>
                </template>
                <template v-if="!tags || !tags.length">
                  <!-- 占位置 -->
                  <span style="opacity: 0">0</span>
                </template>
                <template v-if="!readonly">
                  <a-input
                    v-if="inputVisible"
                    ref="input"
                    type="text"
                    size="small"
                    :style="{ width: '78px' }"
                    :value="inputValue"
                    @change="handleInputChange"
                    @blur="handleInputConfirm"
                    @keyup.enter="handleInputConfirm"
                  />
                  <a-tag v-else style="background: #fff; borderStyle: dashed;" @click="showInput">
                    <a-icon type="plus" /> New Tag
                  </a-tag>
                </template>
              </a-form-item>
            </a-col>
            <a-col
              v-if="$store.getters.user.role === 5"
              span="24"
            >
              <!-- 用户标签 -->
              <a-form-item
                :label="$t('view-components-components/user-label')"
                class="writePlate"
                :class="{disabled: readonly}"
              >
                <template v-for="tag in userTags">
                  <a-tooltip v-if="tag.length > 20" :key="tag" :title="tag">
                    <a-tag :key="tag" :closable="!readonly" @close="() => handleUserClose(tag)">
                      {{ `${tag.slice(0, 20)}...` }}
                    </a-tag>
                  </a-tooltip>
                  <a-tag v-else :key="tag" :closable="!readonly" @close="() => handleUserClose(tag)">
                    {{ tag }}
                  </a-tag>
                </template>
                <template v-if="!userTags || !userTags.length">
                  <!-- 占位置 -->
                  <span style="opacity: 0">0</span>
                </template>
                <template v-if="!readonly">
                  <a-input
                    v-if="inputVisible2"
                    ref="input2"
                    type="text"
                    size="small"
                    :style="{ width: '78px' }"
                    :value="inputValue2"
                    @change="handleUserInputChange"
                    @blur="handleUserInputConfirm"
                    @keyup.enter="handleUserInputConfirm"
                  />
                  <a-tag v-else style="background: #fff; borderStyle: dashed;" @click="showUserInput">
                    <a-icon type="plus" /> New Tag
                  </a-tag>
                </template>
              </a-form-item>
            </a-col>

          </a-row>
        </a-form>
      </div>
      <div style="width: 337px;" />
      <!-- <describe :describe="describe" /> -->
    </div>
    <Modal
      :show-modal="showModal"
      :confirm-text="$t('view-components-components/select')"
      @confirm="confirm"
      @cancel="cancel"
    >
      <div class="modal_title">
        {{ $t('admin-profile-edit/more') }}
      </div>
      <div class="modal_inner">
        <span>{{ $t('admin-profile-edit/nomination') }}</span>
        <a-input style="margin: 0 10px;" />
        <span>{{ $t('admin-profile-edit/rmb') }}</span>
      </div>
    </Modal>
  </div>
</template>
<script>
import Modal from '@/views/components/Modal.vue'
import request from '@/utils/request'

export default {
  components: {
    Modal
  },
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    describe: {
      type: Object,
      default: () => {}
    },
    readonly: {
      type: Boolean,
      default: false
    },
    cates: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      showModal: false,
      request: request,
      tags: [],
      inputVisible: false,
      inputValue: '',
      userTags: [],
      inputVisible2: false,
      inputValue2: ''
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    },
    // 新增：获取当前赛事类型
    currentCompetitionType() {
      return this.$store.state.global.currentCompetitionType
    }
  },
  watch: {
    locale(e) {
      console.log(e) // 根据e对变量重新赋值
    },
    // 监听赛事类型变化，清空类别选择
    currentCompetitionType(newVal, oldVal) {
      console.log('[DEBUG][step1] ===== STEP1 COMPETITION TYPE WATCHER TRIGGERED =====')
      console.log('[DEBUG][step1] newVal:', newVal, 'oldVal:', oldVal)
      console.log('[DEBUG][step1] this.form.category_id before watcher:', this.form.category_id)
      console.log('[DEBUG][step1] this.$parent.isEdit:', this.$parent && this.$parent.isEdit)
      console.log('[DEBUG][step1] this.$parent.isInitializing:', this.$parent && this.$parent.isInitializing)

      if (newVal !== oldVal && oldVal) {
        // 只有在非初始化状态下，用户主动修改赛事类型时才清空类别选择
        if (this.$parent && this.$parent.isInitializing) {
          console.log('[DEBUG][step1] Competition type change during initialization, keeping category_id')
        } else if (this.$parent && this.$parent.userChangedCompetitionType) {
          // 用户主动修改竞赛类型，清空类别选择
          this.form.category_id = ''
          this.$store.commit('global/SET_COMPETITION_CATEGORY', '')
          console.log('[DEBUG][step1] Competition type changed by user, cleared category_id')
        } else if (this.$parent && this.$parent.isEdit && this.form.category_id) {
          // 编辑模式下，如果已经有category_id，说明是从API加载的数据，不清空
          console.log('[DEBUG][step1] Edit mode with existing category_id, keeping category_id:', this.form.category_id)
        } else {
          // 其他情况（如新建模式下的用户操作），清空类别
          console.log('[DEBUG][step1] Other case (new mode or no existing category), clearing category_id')
          this.form.category_id = ''
          this.$store.commit('global/SET_COMPETITION_CATEGORY', '')
        }
      } else {
        console.log('[DEBUG][step1] Competition type watcher condition not met')
      }

      console.log('[DEBUG][step1] this.form.category_id after watcher:', this.form.category_id)
    },
    // 调试：监听 props.cates 变化
    cates: {
      immediate: true,
      handler(newVal) {
        console.log('[DEBUG][step1] ===== STEP1 CATES WATCHER TRIGGERED =====')
        console.log('[DEBUG][step1] cates updated:', newVal && newVal.length, newVal)
        console.log('[DEBUG][step1] current form.category_id:', this.form && this.form.category_id)
        console.log('[DEBUG][step1] this.$parent.isEdit:', this.$parent && this.$parent.isEdit)

        if (newVal && newVal.length && this.form && this.form.category_id !== '' && this.form.category_id !== undefined && this.form.category_id !== null) {
          const matched = newVal.find(i => String(i.value) === String(this.form.category_id))
          console.log('[DEBUG][step1] matched cate in step1:', matched)

          if (matched) {
            // 如果找到匹配的类别，确保表单中的值正确设置
            console.log('[DEBUG][step1] Found matching category, setting form.category_id to:', matched.value)
            this.form.category_id = matched.value
            console.log('[DEBUG][step1] category_id matched and set to:', matched.value)
          } else {
            // 如果没有找到匹配的类别，保持原值但添加调试信息
            console.warn('[DEBUG][step1] No matched cate for category_id:', this.form.category_id)
            console.log('[DEBUG][step1] Available cates:', newVal.map(c => ({ value: c.value, name: c.name })))
            console.log('[DEBUG][step1] Keeping original category_id:', this.form.category_id)
          }
        } else {
          console.log('[DEBUG][step1] Conditions not met for category matching')
          console.log('[DEBUG][step1] - newVal && newVal.length:', newVal && newVal.length)
          console.log('[DEBUG][step1] - this.form:', !!this.form)
          console.log('[DEBUG][step1] - this.form.category_id:', this.form && this.form.category_id)
        }
      }
    },
    // 调试：监听 form.category_id 变化
    'form.category_id'(v) {
      console.log('[DEBUG][step1] form.category_id changed ->', v)
    }
  },
  created() {
    setTimeout(() => {
      console.log('form.category_id', this.form)
      this.tags = this.form.product_label
      this.userTags = this.form.user_label
    }, 1000)
    // 新增：检查赛事类型是否为空，若为空跳转回add.vue
    // if (!this.currentCompetitionType) {
    //   this.$router.push('/user/registration/add') // 假设add.vue的路由路径为此，需根据实际路由配置调整
    // }
  },
  methods: {
    confirm() {
      this.showModal = false
    },
    cancel() {
      this.showModal = false
    },
    handleClose(removedTag) {
      const tags = this.tags.filter(tag => tag !== removedTag)
      this.tags = tags
      this.form.product_label = tags
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(function() {
        this.$refs.input.focus()
      })
    },
    handleInputChange(e) {
      this.inputValue = e.target.value
    },
    handleInputConfirm() {
      const inputValue = this.inputValue
      let tags = this.tags
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue]
      }
      Object.assign(this, {
        tags,
        inputVisible: false,
        inputValue: ''
      })
      this.form.product_label = this.tags
    },
    handleTypeChange(value) {
      // 提交到Vuex（假设global模块已启用namespaced）
      this.$store.commit('global/SET_COMPETITION_CATEGORY', value)
    },
    handleUserClose(removedTag) {
      const tags = this.userTags.filter(tag => tag !== removedTag)
      this.userTags = tags
      this.form.user_label = tags
    },
    showUserInput() {
      this.inputVisible2 = true
      this.$nextTick(function() {
        this.$refs.input2.focus()
      })
    },
    handleUserInputConfirm() {
      const inputValue = this.inputValue2
      let tags = this.userTags
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue]
      }
      Object.assign(this, {
        userTags: tags,
        inputVisible2: false,
        inputValue2: ''
      })
      console.log(this.userTags)
      this.form.user_label = this.userTags
    }
  }
}
</script>
<style scoped>
  .content {
    display: flex;
  }

  .form {
    flex: 1;
  }

  .formBox {
    margin-right: 54px;
  }

  .tip {
    text-decoration: underline;
  }

  .modal_title {
    font-size: 24px;
  }

  .modal_inner {
    margin-top: 29px;
    display:flex;
    line-height: 32px;
    white-space: nowrap;
  }
</style>
<style>
  .writePlate .ant-form-item-control {
    background: #ffffff;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 0 11px;
  }

  .writePlate.disabled .ant-form-item-control {
    background: #f5f5f5;
  }
</style>
